<script setup>
import { computed } from 'vue';
import MediaBankEntry from './util/media-bank-entry.vue';

const props = defineProps({
    containerRef: {
        type: String,
        required: true
    },
    uuid: {
        type: String,
        require: true
    },
    content: {
        type: Object,
        required: true
    }
})

const roundingClass = computed(() => {
    if (props.content?.rounding === 'siteAppearance') {
        return 'rounded-wl';
    }
    if (props.content?.rounding === 'none') {
        return 'rounded-none';
    }
    if (props.content?.rounding === 'slight') {
        return 'rounded-lg';
    }
    if (props.content?.rounding === 'medium') {
        return 'rounded-3xl';
    }
    if (props.content?.rounding === 'very') {
        return 'rounded-5xl';
    }

    return 'rounded-wl';
})
</script>
<template>
    <div class="mx-auto overflow-hidden" :class="roundingClass">
        <MediaBankEntry
            v-if="content.media_bank_entry_id"
            :container-ref="containerRef"
            :block-uuid="uuid"
            :block-content="content"
            :media-bank-entry-id="content.media_bank_entry_id"
            property-name="media_bank_entry_id"
            :autoplay="content.autoplay"
            :hide-controls="content.hideControls"
            :loop="content.loop"
            :video-poster-media-bank-entry-id="content.thumbnail_media_bank_entry_id"
        ></MediaBankEntry>
    </div>
</template>
